import { useEffect, useId, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppState } from '@/composables/useAppState'
import { useGSAP } from '@/composables/useGSAP'
import { useImageFormatContext } from '@/composables/useImageFormatContext'
import { getContentfulUrl } from '@/utils/contentful'

export default function SummaryHeroPupil() {
  const id = useId()
  const { persona } = useAppState()
  const { t } = useTranslation()
  const { gsap } = useGSAP()

  const elementRef = useRef<HTMLDivElement>(null)
  const pathRef = useRef<SVGPathElement>(null)
  const imgRef = useRef<HTMLImageElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline({ delay: 0.7 })
        .fromTo(
          pathRef.current,
          {
            scale: 0,
            rotate: 180,
            transformOrigin: 'center',
          },
          {
            scale: 1,
            rotate: 0,
            duration: 1,
            ease: 'power1.out',
          },
          0
        )
        .fromTo(
          elementRef.current,
          {
            scale: 0,
            // rotate: 180,
          },
          {
            scale: 1,
            // rotate: 0,
            duration: 1,
            ease: 'back.out(1.7)',
          },
          0
        )
    })

    return () => ctx.kill()
  }, [pathRef, gsap])

  const betterFormat = useImageFormatContext()
  const [imageUrl, setImageUrl] = useState(null)
  useEffect(() => {
    const url = getContentfulUrl(`/src/assets/images/chat/${persona}_big.jpg`, {
      h: window.innerWidth < 768 ? 240 : 560,
      fm: betterFormat,
    })
    setImageUrl(url)
  }, [persona, betterFormat])

  return (
    <div ref={elementRef} className='absolute top-0 left-0 w-full h-full flex items-center justify-center' aria-hidden>
      <svg aria-hidden className='absolute' viewBox='0 0 1 1'>
        <defs>
          <clipPath id={`clipPersona-${id}`} clipPathUnits='objectBoundingBox'>
            {/* <path ref={pathRef} d="M181.47 7.02538L139.828 0.918772C117.084 -2.41945 93.9453 3.41795 75.4999 17.1432L41.7363 42.2696C23.2998 55.9904 11.0642 76.4819 7.73046 99.2257L1.62385 140.868C-1.71437 163.612 4.12303 186.751 17.8483 205.196L42.9747 238.96C56.7 257.401 77.1869 269.636 99.9308 272.975L141.573 279.081C164.317 282.419 187.456 276.582 205.901 262.857L239.665 237.73C258.106 224.005 270.341 203.518 273.68 180.774L279.786 139.132C283.125 116.388 277.287 93.2492 263.562 74.8038L238.435 41.0402C224.71 22.5992 204.223 10.3636 181.479 7.02538H181.47Z" /> */}
            <path
              ref={pathRef}
              d='M0.6481071428571429 0.025090642857142856L0.4993857142857143 0.0032813285714285716C0.4181571428571429 -0.008640892857142857 0.33551892857142857 0.012206964285714285 0.2696425 0.061225714285714286L0.14905821428571428 0.15096285714285712C0.08321357142857143 0.1999657142857143 0.039515 0.2731496428571428 0.027608785714285714 0.3543775L0.005799464285714285 0.5031C-0.00612275 0.5843285714285714 0.014725107142857142 0.6669678571428571 0.06374392857142856 0.7328428571428571L0.15348107142857143 0.8534285714285714C0.2025 0.9192892857142857 0.27566749999999995 0.9629857142857143 0.3568957142857143 0.9749107142857144L0.5056178571428571 0.9967178571428572C0.5868464285714285 1.0086392857142856 0.6694857142857142 0.9877928571428571 0.7353607142857144 0.9387750000000001L0.8559464285714286 0.8490357142857142C0.9218071428571428 0.8000178571428571 0.9655035714285715 0.72685 0.9774285714285714 0.6456214285714286L0.9992357142857143 0.4969C1.0111607142857142 0.4156714285714286 0.9903107142857142 0.33303285714285713 0.9412928571428572 0.2671564285714286L0.8515535714285715 0.14657214285714285C0.8025357142857144 0.08071142857142857 0.7293678571428572 0.037012857142857146 0.6481392857142858 0.025090642857142856H0.6481071428571429Z'
            />
          </clipPath>
        </defs>
      </svg>
      <div
        className='min-h-[120px] md:min-h-[280px] h-1/2 aspect-square'
        style={{
          clipPath: `url(#clipPersona-${id})`,
        }}
      >
        <img ref={imgRef} className='block w-full h-full object-cover' src={imageUrl} alt={t(`${persona}.name`)} />
      </div>
    </div>
  )
}
